/**
 * Customer-facing support contact — single source of truth.
 *
 * The company moved from `prodagi.ai` to `askprodigy.ai`, and the support
 * address was hard-coded in five user-visible places (billing's Enterprise
 * mailto, the widget maintenance card, the connector docs page, the domain
 * identities toast, the Integrations write-op warning). Flipping the domain
 * meant finding all of them, and a miss ships a dead mailto to a customer.
 *
 * 🚨 Deliberately NOT an `import.meta.env` value, unlike everything in
 * `appConfig.ts`. Frontend env is baked at build time and the deploy env
 * files are gitignored, so an env var would not travel with the repo — a
 * build on a machine without the file would silently fall back. A constant
 * is checked in, reviewable, and identical in every distribution.
 *
 * Visible text must render this constant too, never just the `href`, or the
 * link and the label drift apart on the next domain move.
 */
export const SUPPORT_EMAIL = 'support@askprodigy.ai';

/** `mailto:` form of {@link SUPPORT_EMAIL}. Append `?subject=…` as needed. */
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
